
class ProductReviews extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-review-list]');
    this.form = this.querySelector('[data-review-form]');
    this.status = this.querySelector('[data-review-status]');
    this.visible = Number(this.dataset.visible || 4);

    const sortSelect = this.querySelector('[data-review-sort]');
    sortSelect?.addEventListener('change', (e) => this.sort(e.target.value));

    this.querySelectorAll('[data-review-sort-option]').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.setSort(btn.dataset.reviewSortOption);

        const wrap = btn.closest('.jsSlideToggleWrap');
        if (wrap) wrap.querySelector('.jsSlideToggle')?.click();
        else this.closeSortMenu(true);
      });
    });

    this.sortMenu = this.querySelector('[data-review-sort-menu]');
    if (this.sortMenu) this.initSortMenu();

    this.fileInput = this.querySelector('[data-review-files]');
    this.previewBox = this.querySelector('[data-file-preview]');
    this.fileInput?.addEventListener('change', () => this.renderPreviews());

    this.querySelector('[data-review-more]')?.addEventListener('click', (e) => {

      const hiddenItems = this.items().filter((li) => li.hasAttribute('hidden'));
      if (!hiddenItems.length) { this.hideMore(e.currentTarget); return; }
      hiddenItems.slice(0, this.step).forEach((li) => li.removeAttribute('hidden'));
      this.visible += this.step;
      if (hiddenItems.length <= this.step) this.hideMore(e.currentTarget);
    });

    this.list?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-review-orig]');
      if (!btn || !this.contains(btn)) return;

      const li = btn.closest('li');
      const box = li?.querySelector('[data-review-orig-text]');
      if (!box) return;
      const show = box.hasAttribute('hidden');
      box.toggleAttribute('hidden', !show);
      btn.setAttribute('aria-expanded', String(show));
      btn.classList.toggle('is-open', show);
      if (show) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });

    const modal = this.querySelector('[data-reviews-modal]');
    if (modal) {
      const open = () => { modal.hidden = false; modal.classList.add('openModal'); document.body.style.overflow = 'hidden'; };
      const close = () => { modal.classList.remove('openModal'); modal.hidden = true; document.body.style.overflow = ''; };
      this.querySelector('[data-reviews-open]')?.addEventListener('click', open);
      modal.addEventListener('click', (e) => {
        if (e.target === modal || e.target.closest('[data-reviews-close]')) close();
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
    }

    this.form?.addEventListener('submit', (e) => this.submit(e));
  }

  get step() { return Number(this.dataset.step) || 2; }

  items() {
    return Array.from(this.list?.children || []);
  }

  hideMore(btn) {
    const wrap = btn.closest('.reviews__pagination');
    (wrap || btn).remove();
  }

  setSort(mode) {
    let label = '';
    this.querySelectorAll('[data-review-sort-option], [data-review-sort-pick]').forEach((b) => {
      const on = (b.dataset.reviewSortOption || b.dataset.reviewSortPick) === mode;
      b.classList.toggle('is-active', on);

      if (b.getAttribute('role') === 'option') {
        b.setAttribute('aria-selected', String(on));
        b.tabIndex = on ? 0 : -1;
      }
      if (on && !label) label = this.sortLabel(b);
    });

    const head = this.querySelector('[data-review-sort-current]');
    if (head && label) head.textContent = label;

    const sel = this.querySelector('[data-review-sort]');
    if (!sel) { this.sort(mode); return; }
    if (sel.value === mode) return;
    sel.value = mode;
    sel.dispatchEvent(new Event('change'));
  }

  sortLabel(btn) {
    return (btn.querySelector('[data-review-sort-label]') || btn).textContent.trim();
  }

  currentSort() {
    return this.querySelector('[data-review-sort]')?.value || '';
  }

  initSortMenu() {
    this.sortHead = this.sortMenu.querySelector('[data-review-sort-head]');
    this.sortList = this.sortMenu.querySelector('[data-review-sort-list]');
    this.sortSheet = document.getElementById(this.sortMenu.dataset.reviewSortSheet || '');
    this.mqNarrow = window.matchMedia('(max-width: 768px)');

    this.onOutside = (e) => { if (!this.sortMenu.contains(e.target)) this.closeSortMenu(); };

    this.sortHead?.addEventListener('click', () => {
      if (this.mqNarrow.matches) this.openSortSheet();
      else this.toggleSortMenu(!this.sortMenu.classList.contains('active'));
    });
    this.sortHead?.addEventListener('keydown', (e) => {
      if (this.mqNarrow.matches || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      e.preventDefault();
      this.toggleSortMenu(true);
    });
    this.sortList?.addEventListener('keydown', (e) => this.sortKeys(e, this.sortList, true));

    this.mqNarrow.addEventListener('change', () => {
      this.closeSortMenu();
      this.sortSheet?.close?.();
    });

    this.initSortSheet();
  }

  toggleSortMenu(open) {
    this.sortMenu.classList.toggle('active', open);
    this.sortHead?.setAttribute('aria-expanded', String(open));
    if (open) {
      document.addEventListener('pointerdown', this.onOutside);

      (this.sortList?.querySelector('[aria-selected="true"]') || this.sortList?.firstElementChild)?.focus({ preventScroll: true });
    } else {
      document.removeEventListener('pointerdown', this.onOutside);
    }
  }

  closeSortMenu(toHead) {
    if (!this.sortMenu?.classList.contains('active')) return;
    this.toggleSortMenu(false);
    if (toHead) this.sortHead?.focus();
  }

  sortKeys(e, list, escapes) {
    const opts = Array.from(list.querySelectorAll('[role="option"]'));
    const at = opts.indexOf(document.activeElement);
    const go = (n) => { e.preventDefault(); opts[(n + opts.length) % opts.length]?.focus(); };

    if (e.key === 'ArrowDown') go(at + 1);
    else if (e.key === 'ArrowUp') go(at - 1);
    else if (e.key === 'Home') go(0);
    else if (e.key === 'End') go(opts.length - 1);
    else if (e.key === 'Tab' && escapes) this.closeSortMenu();
    else if (e.key === 'Escape' && escapes) { e.preventDefault(); this.closeSortMenu(true); }
  }

  initSortSheet() {
    if (!this.sortSheet) return;
    const list = this.sortSheet.querySelector('[role="listbox"]');
    list?.addEventListener('keydown', (e) => this.sortKeys(e, list, false));

    this.sortSheet.addEventListener('click', (e) => {
      const pick = e.target.closest('[data-review-sort-pick]');
      if (pick) { this.markSheet(pick.dataset.reviewSortPick); return; }
      if (!e.target.closest('[data-review-sort-apply]')) return;
      this.setSort(this.sheetPick || this.currentSort());
      this.sortSheet.close();
    });
  }

  openSortSheet() {
    this.markSheet(this.currentSort());
    this.sortSheet?.open?.(this.sortHead);

    this.sortSheet?.querySelector('[aria-selected="true"]')?.focus({ preventScroll: true });
  }

  markSheet(mode) {
    this.sheetPick = mode;
    this.sortSheet?.querySelectorAll('[data-review-sort-pick]').forEach((b) => {
      const on = b.dataset.reviewSortPick === mode;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', String(on));
      b.tabIndex = on ? 0 : -1;
    });
  }

  async loadVotes() {
    this.votes = {};
    const endpoint = (this.dataset.endpoint || '').replace(/\/$/, '');
    const ids = this.items().map((li) => li.dataset.reviewId).filter(Boolean);
    if (!endpoint || !ids.length) return;

    const packs = [];
    for (let i = 0; i < ids.length; i += 25) packs.push(ids.slice(i, i + 25));
    try {
      const parts = await Promise.all(packs.map((p) => fetch(
        `${endpoint}/public/review-votes?ids=${p.map(encodeURIComponent).join(',')}`,
      ).then((r) => r.json())));
      parts.forEach((p) => Object.assign(this.votes, p.votes || {}));
    } catch {  }
    this.paintVotes();
  }

  paintVotes() {
    this.items().forEach((li) => {
      const v = this.votes[li.dataset.reviewId];
      if (!v) return;
      const up = li.querySelector('[data-review-vote="up"] [data-review-votes]');
      const down = li.querySelector('[data-review-vote="down"] [data-review-votes]');
      if (up) up.textContent = v.up || 0;
      if (down) down.textContent = v.down || 0;
    });
  }

  sort(mode) {
    if (!this.list) return;

    if (mode === 'helpful' && !this.votes) { this.loadVotes().then(() => this.sort(mode)); return; }

    const rows = this.items();
    const byDate = (li) => Date.parse(li.dataset.date || '') || 0;
    const byRating = (li) => Number(li.dataset.rating || 0);
    const byVotes = (li) => {
      const v = this.votes?.[li.dataset.reviewId];
      return v ? (v.up || 0) - (v.down || 0) : 0;
    };
    const byPhoto = (li) => (li.dataset.photos === '1' ? 1 : 0);

    const newest = (a, b) => byDate(b) - byDate(a);

    const cmp = {
      new: newest,
      old: (a, b) => byDate(a) - byDate(b),
      high: (a, b) => byRating(b) - byRating(a) || newest(a, b),
      low: (a, b) => byRating(a) - byRating(b) || newest(a, b),
      helpful: (a, b) => byVotes(b) - byVotes(a) || newest(a, b),
      photo: (a, b) => byPhoto(b) - byPhoto(a) || newest(a, b),
    }[mode];
    if (!cmp) return;

    rows.sort(cmp).forEach((li) => this.list.append(li));

    const more = this.querySelector('[data-review-more]');
    rows.forEach((li, i) => li.toggleAttribute('hidden', Boolean(more) && i >= this.visible));
  }

  renderPreviews() {
    if (!this.fileInput || !this.previewBox) return;
    const MAX = 4;
    let files = Array.from(this.fileInput.files || []).filter((f) => f && f.size);
    if (files.length > MAX) {
      files = files.slice(0, MAX);
      this.setFiles(files);            
    }
    this.previewBox.textContent = '';
    files.forEach((file, i) => {
      const item = document.createElement('div');
      item.className = 'filePreviewItem';

      const img = document.createElement('img');
      img.className = 'filePreviewImg';
      img.alt = file.name;

      const url = URL.createObjectURL(file);
      img.src = url;
      img.addEventListener('load', () => URL.revokeObjectURL(url), { once: true });

      const del = document.createElement('button');
      del.type = 'button';
      del.className = 'filePreviewDelete';
      del.setAttribute('aria-label', window.themeStrings?.remove || 'Remove');
      del.textContent = '\u00d7';
      del.addEventListener('click', () => {
        this.setFiles(Array.from(this.fileInput.files || []).filter((_, k) => k !== i));
        this.renderPreviews();
      });

      item.append(img, del);
      this.previewBox.append(item);
    });
  }

  setFiles(files) {
    const dt = new DataTransfer();
    files.forEach((f) => dt.items.add(f));
    this.fileInput.files = dt.files;
  }

  async submit(e) {
    e.preventDefault();
    const endpoint = (this.dataset.endpoint || '').replace(/\/$/, '');
    if (!endpoint) return;

    const button = this.form.querySelector('[type="submit"]');
    const data = new FormData(this.form);
    button.disabled = true;
    this.say('', null);

    const locale = (document.documentElement.lang || 'uk').toLowerCase().slice(0, 2);
    try {

      const files = data.getAll('images').filter((f) => f && f.size);
      let request;
      if (files.length) {
        const form = new FormData();
        form.append('subject', this.dataset.subject);
        form.append('author', data.get('author'));
        form.append('rating', String(Number(data.get('rating')) || ''));
        form.append('body', data.get('body'));

        form.append('email', data.get('email') || '');
        form.append('locale', locale);
        files.slice(0, 4).forEach((f) => form.append('images', f, f.name));
        request = { method: 'POST', body: form };
      } else {
        request = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            subject: this.dataset.subject,
            author: data.get('author'),
            rating: Number(data.get('rating')),
            body: data.get('body'),
            email: data.get('email') || '',
            locale,
          }),
        };
      }
      const res = await fetch(`${endpoint}/public/reviews`, request);
      const out = await res.json();
      if (!out.ok) throw new Error(out.error || '');
      this.form.reset();

      this.renderPreviews();
      this.say(window.themeStrings?.reviewThanks, 'ok');
    } catch (err) {
      this.say(err.message || window.themeStrings?.reviewError, 'err');
    } finally {
      button.disabled = false;
    }
  }

  say(text, kind) {
    if (!this.status) return;
    this.status.textContent = text || '';
    this.status.className = `review-form__status${kind ? ` is-${kind}` : ''}`;
    this.status.hidden = !text;
  }
}

customElements.define('product-reviews', ProductReviews);

(() => {
  const KEY = 'sa_voter_id';
  const voter = (() => {
    try {
      let v = localStorage.getItem(KEY);
      if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(KEY, v); }
      return v;
    } catch { return null; }          
  })();

  const endpointOf = (el) => el.closest('[data-reviews-endpoint]')?.dataset.reviewsEndpoint
    || document.querySelector('[data-reviews-endpoint]')?.dataset.reviewsEndpoint || '';

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-review-vote]');
    if (!btn || !voter) return;
    const item = btn.closest('[data-review-id]');
    const endpoint = endpointOf(btn).replace(/\/$/, '');
    if (!item || !endpoint || btn.disabled) return;

    btn.disabled = true;
    try {
      const res = await fetch(`${endpoint}/public/review-vote`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ review: item.dataset.reviewId, voter, vote: btn.dataset.reviewVote }),
      });
      const data = await res.json();
      if (!data.ok) return;
      const up = item.querySelector('[data-review-vote="up"] [data-review-votes]');
      const down = item.querySelector('[data-review-vote="down"] [data-review-votes]');
      if (up) up.textContent = data.up;
      if (down) down.textContent = data.down;
      item.querySelectorAll('[data-review-vote]').forEach((b) => {
        b.classList.toggle('is-active', b.dataset.reviewVote === data.mine);
      });
    } catch {  }
    finally { btn.disabled = false; }
  });
})();

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-share-copy]');
  if (!btn) return;
  try {
    await navigator.clipboard.writeText(btn.dataset.shareCopy);
    const was = btn.textContent;
    btn.textContent = window.themeStrings?.linkCopied || was;
    setTimeout(() => { btn.textContent = was; }, 2000);
  } catch (err) {

  }
});

(() => {
  let box, imgEl, urls = [], idx = 0;

  const show = (i) => {
    if (!urls.length) return;
    idx = (i + urls.length) % urls.length;
    imgEl.src = urls[idx];
    box.classList.toggle('is-multi', urls.length > 1);
  };
  const close = () => {
    if (!box || box.hidden) return;
    box.hidden = true;
    imgEl.src = '';
    document.body.style.overflow = '';
  };
  const build = () => {
    box = document.createElement('div');
    box.className = 'rev-lightbox';
    box.hidden = true;
    box.innerHTML =
      '<button type="button" class="rev-lightbox__close" aria-label="Close">&times;</button>'
      + '<button type="button" class="rev-lightbox__nav rev-lightbox__prev" aria-label="Prev">&#8249;</button>'
      + '<img class="rev-lightbox__img" alt="">'
      + '<button type="button" class="rev-lightbox__nav rev-lightbox__next" aria-label="Next">&#8250;</button>';
    imgEl = box.querySelector('.rev-lightbox__img');
    box.addEventListener('click', (e) => {
      if (e.target === box || e.target.closest('.rev-lightbox__close')) { close(); return; }
      if (e.target.closest('.rev-lightbox__prev')) show(idx - 1);
      else if (e.target.closest('.rev-lightbox__next')) show(idx + 1);
    });
    document.body.append(box);
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('.sa-rev__photos a, .review__photos a');
    if (!a) return;
    e.preventDefault();
    const links = [...a.closest('ul').querySelectorAll('a')];
    urls = links.map((l) => l.getAttribute('href')).filter(Boolean);
    if (!box) build();
    show(links.indexOf(a));
    box.hidden = false;
    document.body.style.overflow = 'hidden';
  });
  document.addEventListener('keydown', (e) => {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'ArrowRight') show(idx + 1);
  });
})();
